import { render, staticRenderFns } from "./DomainRegistrationContact.vue?vue&type=template&id=4a1187c2&"
import script from "./DomainRegistrationContact.vue?vue&type=script&lang=js&"
export * from "./DomainRegistrationContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports